var exports = {
  "n": "x86173eed--98b3ab--link",
  "G": "x86173eed--98b3ab--link-active",
};

module.exports = exports;
